import classNames from 'classnames';
import { memo, type ReactNode } from 'react';

import { XIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Portal } from '@air/primitive-portal';

export type FiltersMobileContainerProps = {
  content: ReactNode;
  onClose: () => void;
};

export const MobileFiltersContainer = memo(({ content, onClose }: FiltersMobileContainerProps) => {
  return (
    <Portal>
      <div className="fixed inset-y-0 left-0 flex h-full w-screen flex-col ads:bg-raised bg-surface-1">
        <div className="flex size-full shrink-0 flex-col overflow-auto ads:bg-raised bg-gray-2">{content}</div>
        <IconButton
          appearance="ghost"
          className={classNames('absolute z-10', 'top-2 right-4')}
          color="gray"
          adsIcon
          icon={XIcon}
          label="Close filters"
          onClick={onClose}
          size="large"
        />
      </div>
    </Portal>
  );
});

MobileFiltersContainer.displayName = 'MobileFiltersContainer';
